<form [formGroup]="emailForm" (ngSubmit)="onSubmit(emailForm.value)">
    <fieldset>
        <legend>Credential Maintenance Assessment Report</legend>
        <div>Send To Email Address:</div>
        <div class="field">
            <div class="field__label-input-wrap">
<!--                 <label for="email" class="label">
                    Email Address
                </label> -->
                <input class="input input--large" id="email" type="email" name="email" [class.input--invalid]="formErrors.email" formControlName="email" maxlength="150">
                <div *ngIf="formErrors.email" class="error-message field__error-message">{{ formErrors.email }}</div>
            </div>
        </div>
        <div class="form-actions form-actions--multi-step">
            <input ng-disabled="!isValidEmail()" class="button form-actions__item form-actions__item--continue" type="submit" value="Continue" />
            <button (click)="onBack($event)" class="button button--secondary form-actions__item form-actions__item--back">Back</button>
        </div>
    </fieldset>
</form>